import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  inject,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { Location } from '@angular/common';
import { FieldType } from '@ngx-formly/core';

import { AnnuityLookupComponent } from '../../../annuity-lookup/annuity-lookup/annuity-lookup.component';
import { RixtremaLookupComponent } from '../../../rixtrema/rixtrema-lookup/rixtrema-lookup.component';
import { FundFeeHandlerComponent } from '../../../fund-fee-lookup/fund-fee-handler/fund-fee-handler.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-form-button',
  styleUrls: ['form-button.component.scss'],
  template: `
    @if (props.buttonType === 'beacon') {
      <app-annuity-lookup
        [formlyAttributes]="field"
        [index]="field.parent.key"
        [fieldData]="field"
      />
    } @else if (rixtremaButtonTypes.includes(props.buttonType)) {
      <app-rixtrema-lookup
        [formlyAttributes]="field"
        [fieldData]="field"
        [buttonType]="props.buttonType"
        [type]="props.model.UnitRolloverSettings_ExternalSource"
      />
    } @else if (props.buttonType === 'fundSearch') {
      <app-fund-fee-handler
        [fieldData]="field"
        [varSet]="varSet"
        [group]="props.group"
      />
    } @else if (props.buttonType === 'IWProductShelfButton') {
      <button
        mat-button
        class="mb-2 product-shelf-btn"
        color="primary"
        type="button"
        (click)="onLinkClick($event)"
      >
        <mat-icon class="me-2">launch</mat-icon>{{ to.label }}
      </button>
    } @else {
      <button
        mat-button
        color="primary"
        type="button"
        [formlyAttributes]="field"
        (click)="onClick($event)"
        >{{ to.label }}</button
      >
    }
  `,
  imports: [
    AnnuityLookupComponent,
    RixtremaLookupComponent,
    FundFeeHandlerComponent,
    MatButtonModule,
    MatIconModule,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class FormlyButtonComponent extends FieldType implements OnInit {
  @Output() returnData = new EventEmitter();
  private location = inject(Location);

  varSet = 'CurrentPlanDetailsArray';
  rixtremaButtonTypes = [
    'rixtrema',
    'newPlanSearch',
    'search401k',
    'search403b',
    'searchMP',
    'searchPension',
    'searchESOP',
  ];

  ngOnInit() {
    if (this.props.buttonType === 'fundSearch') {
      this.varSet = (this.key as string).split('_')[0];
    }
  }

  onClick($event) {
    if (this.props.onClick) {
      this.props.onClick($event);
    }
  }

  onLinkClick(ev) {
    window.open(
      `${this.location.prepareExternalUrl('/iw/product-shelf/')}`,
      '_blank'
    );
  }
}
